import React, {Component} from 'react';
import withThemeProvider from "../hoc/withThemeProvider";
import Category from "./Category";
import CategoryGroupName from "./CategoryGroupName";
import CategoryGroup from "./CategoryGroup";
import Popup from "./Popup";
import ChecklistService from "../services/checklist";

class Kit extends Component {
    state = {
        selectedGroupIndex: null,
        checklist: {},
        showSignIn: false,
    };

    constructor(props) {
        super(props);
        this.state.checklist = props.checklist;
    }

    check = async (value, category) => {
        const {registered} = this.props;
        if (!registered) {
            this.setState({
                showSignIn: true,
            });
            return;
        }

        const oldChecked = category.IsChecked;
        const newChecked = value;

        category.IsChecked = newChecked;
        this.setState({
            checklist: this.state.checklist,
        });

        let checked = oldChecked;
        try {
            checked = await ChecklistService.checked({
                checklistid: category.ChecklistId,
                ischecked: newChecked,
            })
        } catch (e) {
        }

        category.IsChecked = checked;
        this.setState({
            checklist: this.state.checklist,
        });
    };

    select = (index) => {
        this.setState({
            selectedGroupIndex: index,
        });
    };

    onPopupClose = () => {
        this.setState({
            showSignIn: false,
        });
    };

    render() {
        const {selectedGroupIndex, checklist, showSignIn} = this.state;
        const {registered, loginUrl, loginButtonText, description, singleColumnCount} = this.props;

        const selectedGroup = selectedGroupIndex !== null ? checklist.CategoryGroups[selectedGroupIndex] : null;

        return <>
            <div className="row">
                <div className="col-12 col-md-4">
                    <div className="border-top">
                        <div className="row">
                            {
                                checklist.CategoryGroups.map((categoryGroup, index) =>
                                    <div className="col-12" key={index}>
                                        <CategoryGroup categoryGroup={categoryGroup}
                                                       selected={selectedGroupIndex === index}
                                                       onSelect={() => this.select(index)}
                                                       check={this.check}/>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
                {selectedGroup &&
                <div className="d-none d-md-block col-8 col-lg-6">
                    <CategoryGroupName>
                        {selectedGroup.CategoryGroupName}
                    </CategoryGroupName>
                    <div className="row">
                        <div className="col-12">
                            {selectedGroup.Categories.map((category) =>
                                <Category key={category.ChecklistId}
                                          category={category}
                                          check={this.check}
                                />
                            )}
                        </div>
                    </div>
                </div>
                }
            </div>
            {!registered &&
            <Popup show={showSignIn} onClose={this.onPopupClose} loginUrl={loginUrl} description={description} loginButtonText={loginButtonText}/>}
        </>
    }
}

export default withThemeProvider(Kit);
